export const landingpage_exposure = 'landingpage_exposure'
export const landingpage_login = 'landingpage_login'
export const landingpage_aicreate = 'landingpage_aicreate'
export const landingpage_freeuse = 'landingpage_freeuse'
export const landingpage_logo_drag = 'landingpage_logo_drag'

/** 技能落地页 @app/(site)/skill */
export const landingpage_skills_exposure = 'landingpage_skills_exposure'
export const landingpage_skills_top_copy_click = 'landingpage_skills_top_copy_click'
export const landingpage_skills_multi_chart_copy_click = 'landingpage_skills_multi_chart_copy_click'
export const landingpage_skills_multi_chart_download_click = 'landingpage_skills_multi_chart_download_click'
export const landingpage_skills_data_report_copy_click = 'landingpage_skills_data_report_copy_click'
export const landingpage_skills_data_report_download_click = 'landingpage_skills_data_report_download_click'
export const landingpage_skills_sankey_chart_copy_click = 'landingpage_skills_sankey_chart_copy_click'
export const landingpage_skills_sankey_chart_download_click = 'landingpage_skills_sankey_chart_download_click'
export const landingpage_skills_3d_chart_copy_click = 'landingpage_skills_3d_chart_copy_click'
export const landingpage_skills_3d_chart_download_click = 'landingpage_skills_3d_chart_download_click'
export const landingpage_skills_footer_copy_click = 'landingpage_skills_footer_copy_click'
